import type { ReactNode } from 'react'
import { CircleDashed } from 'lucide-react'
import { Button } from './Button'

export function Skeleton({ className = '' }: { className?: string }) { return <span aria-hidden="true" className={`skeleton ${className}`} /> }

export function EmptyState({ title, body, action, icon, level = 2 }: { title: string; body: string; action?: ReactNode; icon?: ReactNode; level?: 1 | 2 }) {
  const Heading = level === 1 ? 'h1' : 'h2'
  return <div className="empty-state"><div className="empty-state-icon" aria-hidden="true">{icon ?? <CircleDashed size={28} strokeWidth={1.7} />}</div><Heading>{title}</Heading><p>{body}</p>{action}</div>
}

export function ErrorState({ title = 'We could not load this yet', body, onRetry, retrying = false }: { title?: string; body: string; onRetry?: () => void; retrying?: boolean }) {
  return <div className="error-state" role="alert"><strong>{title}</strong><p>{body}</p>{onRetry && <Button loading={retrying} disabled={retrying} onClick={onRetry}>Try again</Button>}</div>
}
